import { useTheme } from "@/lib/theme";
import { cn } from "@/lib/utils";

/**
 * Datanomy logo. "full" is the wordmark, whose white-text variant follows the resolved theme (incl. "system");
 * "mark" is the square "D" for tight spaces (collapsed sidebar), which reads on both themes.
 */
export function DatanomyLogo({ variant = "full", className }: { variant?: "full" | "mark"; className?: string }) {
  const { resolvedTheme } = useTheme();
  if (variant === "mark") {
    return (
      <img src="/brand/datanomy-mark.png" alt="Datanomy Technologies" width={179} height={145} className={cn("h-7 w-auto shrink-0", className)} />
    );
  }
  const src = resolvedTheme === "dark" ? "/brand/datanomy-logo-full-onDark.png" : "/brand/datanomy-logo-full.png";
  return (
    <img
      src={src}
      alt="Datanomy Technologies"
      width={663}
      height={145}
      data-theme-variant={resolvedTheme}
      className={cn("h-7 w-auto shrink-0", className)}
    />
  );
}
